import React, {Component} from "react";
import {Modal} from "antd";
import CustomMap from "../../../ProposalDetail/Component/Common/CustomMap";

class PreviewMap extends Component {
  render() {
    const {visible, handleCancel, markers} = this.props;
    return (
      <Modal
        title={'View PWS Map'}
        visible={visible}
        onCancel={() => handleCancel()}
        footer={[
          <button key="cancel" className="btn btn-warning" onClick={() => handleCancel()}>Ok</button>,
        ]}
      >
        {markers?.length > 0 ? <div className="map">
          <CustomMap markers={markers} containerStyle={{height: "400px"}} zoomControl={true}/>
        </div> : <div>PWS map not found</div> }
      </Modal>
    );
  }
}

export default PreviewMap;